export default __webpack_public_path__ + "static/media/falafel.6e58815c.jpg";